// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"540":"6bf1a75d3ee670d0e2b2","961":"ace9a60b21b690831a95"}[chunkId] + ".bundle.js";
};